<template>
  <div class="form-container step1">
    <form id="topup-phone-step1" @submit.prevent="submit">
      <div class="form-row">
        <ul class="operator-list">
          <li v-for="(operator, index) in operators" :key="'operator-' + index" class="operator-item">
            <label :for="'operator-' + index">
              <img :src="getOperatorLogoSrc(operator)" :alt="operator">
              <input type="radio"
                     @change="checkForm"
                     :value="operator"
                     v-model="form.data.operator"
                     :id="'operator-' + index">
              <span class="outline"></span>
            </label>
          </li>
        </ul>
        <div class="error" v-if="form.isSubmited && !form.isValid">Wybierz operatora</div>
      </div>
      <div class="form-row form-buttons">
        <button type="submit" class="btn">Dalej</button>
      </div>
    </form>
  </div>
</template>

<script>
import OperatorMixin from '@/doladujtutaj/mixins/operator.mixin'
import { OPERATORS_TOPUP_ACTIVE } from '@/common/const/operators.const'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { ToolsClass } from '@/common/class/tools.class'

export default {
  name: 'TopupPhoneStep1',
  mixins: [OperatorMixin],
  computed: {
    ...mapGetters({
      formData: 'getData'
    }),
    operators: function () {
      return OPERATORS_TOPUP_ACTIVE
    }
  },
  data () {
    return {
      form: {
        data: {
          operator: null
        },
        isValid: false,
        isSubmited: false
      }
    }
  },
  methods: {
    ...mapMutations(['SET_TOPUP_STAGE']),
    ...mapActions(['setStage1Data']),
    checkForm () {
      this.form.isValid = !!this.form.data.operator
    },
    submit () {
      this.form.isSubmited = true
      if (!this.form.isValid) {
        return
      }

      this.setStage1Data(this.form.data)
        .then(() => {
          this.SET_TOPUP_STAGE(2)
        })
    }
  },
  created () {
    if (this.formData !== null) {
      this.form.data = ToolsClass.deepExtend(this.formData)
      this.checkForm()
    }
  },
  updated () {
    ToolsClass.sendHeightToIframeParent()
  }
}
</script>
